export default "__VITE_ASSET__17156bad__"